import { isNotNil } from 'shared/src/utils';
import { useReportTTFD } from 'shared/src/hooks';
import { useGoodsBasic } from '../queries/useGoodsBasic';

/**
 * 상품상세 TTFD 리포트.
 *
 * **왜 필요한가** — RN 호스트는 `RN_GoodsDetail` 트랜잭션을 열고 TTID 까지 마킹하지만
 * `PERFORMANCE_TTFD` 이벤트에서만 `finish()` 한다(`AblyReactActivity.kt:133`).
 * PDP 가 이걸 보내지 않아서 **트랜잭션이 미완료로 버려지고 Sentry 에 PDP(RN) 성능 데이터가
 * 하나도 없었다** — `RN_*` 트랜잭션은 `RN_MarketHome`/`RN_Screens` 둘뿐이었다.
 *
 * **왜 마운트 직후가 아닌가** — 네이티브 PDP 의 짝 지표(`GOODS_DETAIL` 트랜잭션)는
 * `GoodsDetailDom` 이 basic 응답으로 `firstRendering`(커버 이미지·마켓명·가격·할인율)을
 * 만드는 시점을 기준으로 한다. RN 이 마운트 직후에 보내면 아직 스켈레톤인 시점이 찍혀
 * **RN 이 유리하게 나오는 엉터리 비교**가 된다. 그래서 basic 도착까지 기다린다.
 *
 * (basic 은 진입 시 `usePreloadQuery` 가 prefetch 하므로 보통 곧 도착한다)
 */
export const useReportGoodsDetailTTFD = () => {
  const { data: goodsBasic } = useGoodsBasic();

  useReportTTFD({ enabled: isNotNil(goodsBasic) });
};
